jQuery(document).ready(function($) {
    if (!window.WebAssessmentCharts) {
        window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
    }    
    let projectID;
    if ($('body').hasClass('single-projects')) {
        // Extract the URL path and split it to get the slug
        const pathParts = window.location.pathname.split('/projects/');
        if (pathParts.length > 1) {
            // Get the slug portion after '/projects/' and remove any trailing slash if present
            projectID = pathParts[1].split('/')[0];
            console.log('Extracted projectID:', projectID); // Verify the extracted project ID
        }
    }

    // Now using utility function from fetchProjectChartData.js
    WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
    var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

    // Fetch project data and CRF data, then process them together
    WebAssessmentCharts.fetchDataAndCalculateScores = async function (projectID) {
        // Extract the URL path and split it to get the slug
        const pathParts = window.location.pathname.split('/projects/');
        if (pathParts.length > 1) {
            // Get the slug portion after '/projects/' and remove any trailing slash if present
            projectID = pathParts[1].split('/')[0];
        }

        try {
            // Fetch project data
            const projectData = await WebAssessmentCharts.fetchProjectChartData(projectID);

            // Check if project data is valid
            if (!projectData || !Array.isArray(projectData)) {
                console.error('Project data is missing or not structured as expected:', projectData);
                return;
            }

            // Process project data
            const projectItems = projectData;
            const processedItems = homeFrameworkProcessUniqueItems(projectItems);
            console.log('Processed Items:', processedItems);
            
            // Fetch CIS standards data directly
            try {
                const response = await jQuery.ajax({
                    url: controlsData.ajax_url,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'api_action',
                        year: '2024',
                        apis: ['CS'],
                        CSLstandardID: 'CIS-5-0'
                    }
                });

                console.log('CIS Standards response structure:', JSON.stringify(response, null, 2));
                // Store the response for use by other functions
                WebAssessmentCharts.cisStandardData = response;

                if (!response.CS || !response.CS.Items) {
                    console.error('Invalid CIS standards response structure:', response);
                    return;
                }

                // Create a map of control IDs to their priorities
                const controlPriorities = {};
                response.CS.Items.forEach(control => {
                    console.log('Processing control:', control);
                    if (control.controlid?.S && control.controlpriority?.S) {
                        controlPriorities[control.controlid.S] = control.controlpriority.S;
                        console.log(`Mapped control ${control.controlid.S} to priority ${control.controlpriority.S}`);
                    } else {
                        console.log('Control missing ID or priority:', control);
                    }
                });

                console.log('Control priorities map:', controlPriorities);

                // Add control priorities to processed items
                const itemsWithPriorities = processedItems.map(item => {
                    console.log('Processing item:', item);
                    const safeguardId = item.safeguardid.S;
                    const priority = controlPriorities[safeguardId];
                    if (priority) {
                        item.controlpriority = { S: priority };
                        console.log(`Added priority ${priority} to safeguard ${safeguardId}`);
                    } else {
                        console.log(`No priority found for safeguard: ${safeguardId}`);
                        console.log('Available control IDs:', Object.keys(controlPriorities));
                    }
                    return item;
                });

                console.log('Items with priorities:', itemsWithPriorities);
                
                // Now run the CIS5 function with the enhanced data
                WebAssessmentCharts.CIS50(itemsWithPriorities, response);

                
            } catch (error) {
                console.error('Error fetching CIS standards:', error);
                WebAssessmentCharts.CIS50(processedItems);
            }

        } catch (error) {
            console.error('Error processing data:', error);
        } finally {
            // Always hide the loader, even if an error occurs
            $('.modal-body .loader').hide();
        }
    };

    if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
        WebAssessmentCharts.registerHomeDashboardFetcher('cis-5-0', WebAssessmentCharts.fetchDataAndCalculateScores);
    }

    // Now using utility function from calculateMaturityScore.js
    WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;

    // Now using utility function from getMostRecentSafeguards.js
    WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;

    // Now using utility function from processUniqueItemsCIS.js
    WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;

    var homeFrameworkCalculateCategoryAverages = WebAssessmentCharts.calculateCategoryAverages = function(items, cisStandardData) {
        const categoryScores = {};
        const categoryPotentialCounts = {};
        
        // First gather potential counts from CIS standard data if available
        if (cisStandardData && cisStandardData.CS && cisStandardData.CS.Items) {
            cisStandardData.CS.Items.forEach(control => {
                if (control.controlid && control.controlid.S) {
                    const safeguardId = control.controlid.S;
                    const category = safeguardId.split('.')[0]; // Get the category (e.g., 14 from 14.1)
                    
                    if (!categoryPotentialCounts[category]) {
                        categoryPotentialCounts[category] = 0;
                    }
                    categoryPotentialCounts[category]++;
                }
            });
        }
        console.log("Category potential counts: ", categoryPotentialCounts);
        
        // Initialize category scores structure with potential counts
        Object.keys(categoryPotentialCounts).forEach(category => {
            categoryScores[category] = { 
                total: 0, 
                count: 0, 
                nullCount: 0, 
                totalItems: 0,
                applicableItems: 0,
                potentialCount: categoryPotentialCounts[category]
            };
        });
        
        // Process actual score data
        items.forEach(item => {
            const safeguardId = item.safeguardid.S;
            const category = safeguardId.split('.')[0]; // Get the category (e.g., 14 from 14.1)
            const maturityScore = item.maturityscore; // Can be null
            const policystatus = parseInt(item.policystatus.N, 10);
            
            if (!categoryScores[category]) {
                categoryScores[category] = { 
                    total: 0, 
                    count: 0, 
                    nullCount: 0, 
                    totalItems: 0,
                    applicableItems: 0,
                    potentialCount: categoryPotentialCounts[category] || 0
                };
            }
            
            categoryScores[category].totalItems++;
            
            // Check if item is Not Applicable (policy status 1)
            if (policystatus === 1) {
                categoryScores[category].nullCount++;
            } else {
                // Item is applicable (whether filled out or not)
                categoryScores[category].applicableItems++;
                
                // Only add to total if it has a maturity score
                if (maturityScore !== null) {
                    categoryScores[category].total += maturityScore;
                    categoryScores[category].count++;
                }
            }
        });
        
        // Calculate averages using applicable items count as denominator
        const averages = {};
        Object.keys(categoryScores).forEach(category => {
            const { total, count, nullCount, totalItems, applicableItems, potentialCount } = categoryScores[category];
            
            // If all items in category are marked as "Not Applicable" (policy status 1), set average to null
            if (nullCount === totalItems && totalItems > 0) {
                averages[category] = null;
            } else {
                // Use applicableItems as denominator (total items minus Not Applicable items)
                const denominator = applicableItems > 0 ? applicableItems : (potentialCount || count);
                averages[category] = denominator > 0 ? total / denominator : 0;
                console.log(`Category ${category}: total=${total}, applicableItems=${applicableItems}, potentialCount=${potentialCount}, actual count=${count}, average=${averages[category]}`);
            }
        });
        
        console.log("Category averages: ", averages);
        
        return averages;
    }

    WebAssessmentCharts.CIS50 = function(items, cisStandardData) {
        console.log('Starting CIS50 function...');
        const tableBody = document.querySelector('#cis5 tbody');
        if (!tableBody) {
            console.error('CIS 5.0 Table body not found.');
            return;
        }

        // Store original row indices before any modifications
        const originalIndices = new Map();
        Array.from(tableBody.rows).forEach((row, index) => {
            originalIndices.set(row, index);
        });

        // Create a map of all possible safeguards from the standard
        const allSafeguards = new Map();
        if (cisStandardData && cisStandardData.CS && cisStandardData.CS.Items) {
            cisStandardData.CS.Items.forEach(control => {
                if (control.controlid && control.controlid.S) {
                    allSafeguards.set(control.controlid.S, {
                        safeguardid: { S: control.controlid.S },
                        policystatus: { N: "0" }, // Default to "Not Answered"
                        maturityscore: 0, // Default score for unanswered items
                        controlpriority: control.controlpriority // Preserve control priority for IG calculations
                    });
                }
            });
        }

        // Merge in any existing answers
        const processedItems = homeFrameworkProcessUniqueItems(items);
        processedItems.forEach(item => {
            allSafeguards.set(item.safeguardid.S, item);
        });

        // Convert back to array
        const mergedItems = Array.from(allSafeguards.values());
        console.log('Merged items (including unanswered):', mergedItems);

        // Calculate averages by category
        const averageScores = homeFrameworkCalculateCategoryAverages(mergedItems, cisStandardData);
        // Keep track of rows to remove
        const rowsToRemove = [];

        // Make all rows visible first
        Array.from(tableBody.rows).forEach(row => {
            row.style.display = '';
        });

        // Update the table
        Object.keys(averageScores).forEach(category => {
            const rowIndex = parseInt(category, 10) - 1; // Convert category to table row index
            const row = tableBody.rows[rowIndex];
            if (row) {
                const averageScore = averageScores[category];
                const scoreCell = row.cells[1];

                if (averageScore === null) {
                    // Only remove rows that are explicitly marked as not applicable
                    // (all items in the category have policy status 1)
                    rowsToRemove.push(row);
                } else {
                    const scaledScore = averageScore * 5; // Scale average score
                    scoreCell.textContent = scaledScore.toFixed(2);
                    console.log(`Updated row ${rowIndex + 1} with averageScore:`, scaledScore.toFixed(2));
                }
            } else {
                console.warn(`Row not found for category ${category} with rowIndex ${rowIndex}`);
            }
        });

        // Remove rows with all null values (all items are Not Applicable)
        rowsToRemove.forEach(row => {
            row.remove();
        });

        // Calculate and update overall maturity score
        let totalScore = 0;
        let scoreCount = 0;
        Array.from(tableBody.rows).forEach((row) => {
            const scoreText = row.cells[1].textContent;
            const score = parseFloat(scoreText);
            if (!isNaN(score)) {
                totalScore += score;
                scoreCount++;
            }
        });

        const maturityRatingRow = $('#cis5 .light-background td');
        if (maturityRatingRow.length > 0 && scoreCount > 0) {
            const overallMaturity = totalScore / scoreCount;
            WebAssessmentCharts.overallCIS50maturity = overallMaturity;
            maturityRatingRow.text(overallMaturity.toFixed(2)); // jQuery method to set text
            $('.audit-overall-value').text(overallMaturity.toFixed(2));
            $('.cis5-overall-value').text(overallMaturity.toFixed(2));
            console.log(`Updated overall maturity rating to ${overallMaturity.toFixed(2)}`);

            $('.spinner-border').hide();
            $('.mark-complete-modal-buttons').show();

        } else {
            console.error("Error: No scores found or maturity rating row not found in the table.");
        }

        applyFrameworkPanelVisibility('show', '.cis5-container');
        WebAssessmentCharts.createChartFromTable('cis5', 'cis5-chart', charts, true);

        // Restore original row indices after chart creation
        rowsToRemove.forEach(row => {
            const originalIndex = originalIndices.get(row);
            if (originalIndex !== undefined) {
                tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
                row.style.display = 'none';
            }
        });
    }

    // Object to keep track of charts
    var charts = {};

    $('a.view-table').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var card = $button.closest('.card');
		var dataTable = card.find('.data');
		var chart = card.find('.chart');
		
		var isModal = $('body').hasClass('single-projects');
		var $scrollContainer = isModal ? $('.modal.show .modal-body') : $('html, body');

		// Instantly toggle the table's visibility
		dataTable.toggle();

		// Use a minimal timeout to allow the DOM to update after the toggle.
		setTimeout(function() {
			var $targetElement;
			var headerOffset = 20; // Account for sticky headers or other offsets

			// Determine the target element and button text based on visibility
			if (dataTable.is(':visible')) {
				$button.text('Hide Table');
				$targetElement = dataTable; // Our target is the table itself
			} else {
				$button.text('View Table');
				$targetElement = card; // Our target is the card containing the chart
			}
            
            // This is a robust way to calculate the required scroll position.
            var currentScrollTop = $scrollContainer.scrollTop();
            var targetTop = $targetElement[0].getBoundingClientRect().top;
            var containerTop = isModal ? $scrollContainer[0].getBoundingClientRect().top : 0;
            
            var scrollOffset = targetTop - containerTop - headerOffset;
            var newScrollTop = currentScrollTop + scrollOffset;
			
			// Jump instantly to the calculated position.
			$scrollContainer.scrollTop(newScrollTop);
			
		}, 10); // Using a 10ms timeout should be sufficient for reflow.

		// This is part of a hack for the modal height to make it work across browsers
		jQuery('.dashboard-selection').select2('open');
		jQuery('.dashboard-selection').select2('close');
	});

    viewResultsProject = window.location.href;
    let currentProjectID = '';

    // Check if there's a hash in the URL
    if (viewResultsProject.includes('#')) {
        currentProjectID = viewResultsProject.split('#')[1];
    }

    // Extract the project ID from the URL path if it's not available from the hash
    if (!currentProjectID) {
        const projectPath = viewResultsProject.split('/projects/');
        if (projectPath.length > 1) {
            currentProjectID = projectPath[1];  // Extract the part after '/projects/'
        }
    }

	$('.view-results').on('click', function() {
		// Destroy all existing charts
		Object.keys(charts).forEach(chartId => {
			if (charts[chartId]) {
				console.log(`Destroying chart: ${chartId}`);
				charts[chartId].destroy();
				charts[chartId] = null;
			}
		});
		
		// Clear the charts object
		charts = {};
		
		// Show loader
		$('.modal-body .loader').show();
		
		// Extract project ID and fetch data
		let projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			// Extract the slug portion, removing any trailing hashtags or other parts
			currentProjectID = projectPath[1].split(/[?#]/)[0]; // Split by '?' or '#' and take the first part
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		}
	});

    // Event listener for detecting when the #projectCompleteModal is shown
    $(document).on('shown.bs.modal', '#projectCompleteModal', function (event) {
        if (currentProjectID) {
            console.log('Project Complete Modal detected with Project ID:', currentProjectID);
            WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
        } else {
            console.error('Project ID not found for #projectCompleteModal');
        }
    });

    

}); 